import { gql } from "@apollo/client";

export const ServiceReminderList = gql`
    query ServiceReminderList ($installedBaseNodeId: ID!) {
        serviceReminderList (installedBaseNodeId: $installedBaseNodeId) {
            total
            serviceReminders {
                id
                serviceTaskTypeKey
                defaultServiceTask {
                    id
                    name
                    serviceTaskTypeKey
                    recommendedServiceCycle
                }
                nextDueDate
                lastServiceDate
                insert
                update
                lastEditorUser {
                    id
                    name
                }
            }
        }
    }
`;
